import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "reactstrap";

import useUserSharedRecord from "../../api/api-hooks/sharedRecords/useUserSharedRecord";
import SharedCenterSelectedRecordsActions from "./SharedCenterSelectedRecordsActions";
import SharedRecord from "../../components/Drawers/ShareRecordDrawer/SharedRecord";
import ViewRecordDrawer from "../../components/Drawers/Records/ViewRecordDrawer";
import AppDrawer from "../../components/Drawers/AppDrawer";
import CustomTableLayout from "../CustomTableLayout";
import TenantAPI from "../../api/api/TenantAPI";
import useModule from "../../hooks/useModule";

const mainLayout = {
  id: "4",
  Fields: [
    "_RecordName",
    "RecordID",
    "Expires",
    "Sync",
    "ReadOnly",
    "Authentication",
    "Created",
    "CreatedBy",
    "LastUpdated",
    "LastUpdatedBy",
  ],
  ModuleAPIName: "SharedRecords",
  Type: "Table",
};

const viewFilters = (tenantID: string) => [
  {
    Group: true,
    Filters: [
      {
        Group: true,
        Filters: [
          {
            Field: "CloudID",
            Method: "equals",
            Value: tenantID,
          },
        ],
      },
    ],
  },
];

const query = {
  _SelectedLayout: "4",
  Fields: [
    "_RecordName",
    "RecordID",
    "ModuleAPIName",
    "Expires",
    "Sync",
    "ReadOnly",
    "Authentication",
    "Created",
    "CreatedBy",
    "LastUpdated",
    "LastUpdatedBy",
  ],
  Filters: [],
  OrderBy: {
    Field: "Created",
    Direction: "DESC",
  },
  Pagination: {
    Count: 25,
    Page: 1,
  },
};

const hiddenFields = [
  "ModuleAPIName",
  "GlobalAppID",
  "CloudID",
  "CloudsList",
  "Fields",
  "RelatedRecords",
  "RelatedRecordsInfo",
];

const SharedRecordsCenter = () => {
  const { tenantID } = useParams();
  const { module } = useModule("SharedRecords");
  const vFilter = viewFilters(tenantID || "");
  const [recordID, setRecordID] = useState<string>("");
  const [disbaled, setDisabled] = useState(false);
  const sharedRecordRef = useRef<any>();
  const { sharedRecord, expired } = useUserSharedRecord({
    recordID,
  });
  const [recordOpen, setRecordOpen] = useState(false);
  const [shareDrawerOpen, setShareDrawerOpen] = useState(false);

  const { module: recordModule } = useModule(sharedRecord?.ModuleAPIName);

  useEffect(() => {
    if (!sharedRecord) return;

    TenantAPI.getRecordByID(
      sharedRecord?.ModuleAPIName,
      sharedRecord?.RecordID,
      []
    ).then((data) => {
      return data.data.data.data;
    });
  }, [sharedRecord]);

  if (!module) return;

  return (
    <>
      <CustomTableLayout
        title="Shared Records"
        description="All the records shared in this cloud"
        module={module}
        layout={mainLayout}
        initialQuery={query}
        recordNameField="RecordID"
        viewFilter={vFilter}
        hiddenFields={hiddenFields}
        onOpenRecordName={(data) => {
          const record = data.record;
          setRecordID(record.RecordID.id);
          setTimeout(() => {
            setShareDrawerOpen(true);
          }, 200);
          setRecordOpen(true);
        }}
        SelectRecordsActions={SharedCenterSelectedRecordsActions}
      />
      {recordOpen && recordModule && (
        <ViewRecordDrawer
          onClose={() => {
            setRecordOpen(false);
            setRecordID("");
          }}
          open={recordOpen}
          recordID={recordID}
          module={recordModule}
        />
      )}

      <AppDrawer
        open={shareDrawerOpen}
        onClose={() => {
          setShareDrawerOpen(false);
        }}
        headerTitle="Shared Record"
        backdrop
        headerOptions={
          <Button
            style={{ width: 80 }}
            size="sm"
            color="primary"
            onClick={() => sharedRecordRef?.current()}
            disabled={disbaled}
          >
            Update
          </Button>
        }
        body={
          <>
            <SharedRecord
              recordID={sharedRecord?.RecordID}
              recordModule={sharedRecord?.ModuleAPIName}
              globalAppID={sharedRecord?.GlobalAppID}
              sharedRecord={sharedRecord}
              expired={expired}
              sharedRecordRef={sharedRecordRef}
              setDisabled={setDisabled}
              fromSubView={false}
            />
          </>
        }
      />
    </>
  );
};

export default SharedRecordsCenter;
